module.exports = __webpack_public_path__ + "static/media/KR.608a0f43.svg";